export const mockData = {
  trustbar: [
    "★ 4,8/5 (97 avis)",
    "Décennale & RC Pro",
    "Respect des DTU",
    "Intervention sous 48h"
  ],
  
  stats: [
    { value: "+15", label: "années d'expérience" },
    { value: "4,8/5", label: "note moyenne clients" },
    { value: "48h", label: "délai de réponse" },
    { value: "100%", label: "devis détaillés" }
  ],
  
  services: [
    {
      id: 1,
      title: "Réfection & rénovation de toiture",
      description: "Rénovation complète de votre toiture avec matériaux de qualité et respect des DTU.",
      icon: "Home"
    },
    {
      id: 2,
      title: "Zinguerie (zinc, noues, abergements)",
      description: "Pose et réparation de gouttières, chéneaux et tous éléments de zinguerie.",
      icon: "Wrench"
    },
    {
      id: 3,
      title: "Couverture tuiles/ardoises/bac acier",
      description: "Installation de tous types de couverture adaptés à votre région.",
      icon: "Shield"
    },
    {
      id: 4,
      title: "Étanchéité toit-terrasse (EPDM/bitume)",
      description: "Solutions d'étanchéité durables pour toitures plates et terrasses.",
      icon: "Droplets"
    },
    {
      id: 5,
      title: "Nettoyage, démoussage & hydrofuge",
      description: "Entretien de votre toiture pour prolonger sa durée de vie.",
      icon: "Sparkles"
    },
    {
      id: 6,
      title: "Dépannage & urgence 24/7",
      description: "Intervention rapide en urgence pour sécuriser votre toiture.",
      icon: "Phone"
    }
  ],
  
  processSteps: [
    {
      step: 1,
      title: "Visite & photos",
      description: "Diagnostic complet de votre toiture avec rapport détaillé"
    },
    {
      step: 2,
      title: "Devis détaillé",
      description: "Proposition claire avec matériaux et délais précis"
    },
    {
      step: 3,
      title: "Planification",
      description: "Organisation du chantier et commande des matériaux"
    },
    {
      step: 4,
      title: "Pose & finitions",
      description: "Réalisation des travaux par nos équipes qualifiées"
    },
    {
      step: 5,
      title: "Contrôle & nettoyage",
      description: "Vérification finale et nettoyage complet du chantier"
    }
  ],
  
  reviews: [
    {
      id: 1,
      name: "Marie Dupont",
      location: "Toulouse",
      rating: 5,
      comment: "Travail impeccable, équipe professionnelle et respectueuse des délais. Je recommande vivement !",
      date: "2024-01-15"
    },
    {
      id: 2,
      name: "Pierre Martin",
      location: "Cugnaux",
      rating: 5,
      comment: "Intervention rapide suite à une fuite. Réparation durable et prix très correct.",
      date: "2024-01-10"
    },
    {
      id: 3,
      name: "Sophie Leclerc",
      location: "Colomiers",
      rating: 5,
      comment: "Rénovation complète de ma toiture. Résultat parfait, je suis très satisfaite !",
      date: "2024-01-05"
    }
  ],
  
  faqs: [
    {
      id: 1,
      question: "Le devis est-il gratuit ?",
      answer: "Oui, le devis est gratuit pour les chantiers situés dans un rayon de 30 km autour de Cugnaux. Au-delà, des frais de déplacement peuvent s'appliquer et sont déduits si vous signez."
    },
    {
      id: 2,
      question: "Quel est votre délai de réponse ?",
      answer: "Nous répondons sous 24–48h et planifions l'intervention dès signature du devis."
    },
    {
      id: 3,
      question: "Intervenez-vous en urgence ?",
      answer: "Oui, bâchage et sécurisation. Appelez le [TEL] pour une prise en charge immédiate."
    },
    {
      id: 4,
      question: "Couvrez-vous toute l'Occitanie ?",
      answer: "Oui, principalement depuis Cugnaux/Toulouse. Les chantiers éloignés peuvent impliquer des frais logistiques."
    },
    {
      id: 5,
      question: "Quelles garanties proposez-vous ?",
      answer: "Nous proposons une garantie décennale et RC Pro. Toutes nos interventions sont couvertes selon la réglementation en vigueur."
    }
  ]
};